@let showInsuranceTerms =
	recordData().premiumPeriod ||
	recordData().excessAmount ||
	recordData().insuredValue ||
	recordData().coverageType ||
	recordData().coverageType;

<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-item [title]="'shared|pricing-section|duration'" useContent>
			<div class="flex items-center gap-2 flex-wrap">
				<app-date-range-pill
					class="-ml-2"
					[startsAt]="isoDateFrom()"
					[endsAt]="isoDateTo()" />
				<app-expires-at-pill [endsAt]="recordData()?.endsAt?.toISOString()" />
			</div>
		</app-summary-item>
		@if (recordData().externalReference) {
			<app-summary-item
				[title]="
					'vehicle-insurances|record|details-section|field-label|external-reference'
				"
				[value]="recordData().externalReference" />
		}
	</div>

	@if (showInsuranceTerms) {
		<div class="overview-sub-section">
			@if (recordData().premiumPeriod) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|premium-period'
					"
					[value]="
						recordData().premiumPeriod
							| getTranslationKeyFromValue: premiumPeriods
							| transloco
					" />
			}

			@if (recordData().excessAmount) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|excess-amount'
					"
					[value]="recordData().excessAmount" />
			}

			@if (recordData().insuredValue) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|insured-value'
					"
					[value]="recordData().insuredValue" />
			}

			@if (recordData().coverageType) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|coverage-type'
					"
					[value]="
						recordData().coverageType
							| getTranslationKeyFromValue: coverageTypes
							| transloco
					" />
			}

			@if (recordData().totalLossPercentage) {
				<app-summary-item
					[title]="
						'vehicle-insurances|record|details-section|field-label|total-loss-percentage'
					"
					[value]="recordData().totalLossPercentage" />
			}
		</div>
	}

	<div class="flex gap-4 flex-col md:flex-row">
		@if (recordData().vehicleId) {
			<app-vehicle-link-card [id]="recordData().vehicleId" />
		}
	</div>
</app-section-wrapper-container>
